<template>
    <v-container class="pa-0" fluid>
        <v-container v-if="loading">
            <cardWait />
        </v-container>
        <v-card class="pa-2" v-if="!loading">
            <v-card-title class="pt-0 pb-2 justify-center"><h2>Website Faq's</h2> <btn_component ref="info" :tooltip="faqTooltip" type="avatar_text" size="small" text="i" data="" @actionClick="showInfo"/></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                The website FAQ's have been used as a source, but are not linked, any changes here will NOT be synced to the website.<br>
                The FAQ's need to be uploaded to the "openai platform" (ChatGPT) before the assistants can use them.
                Use the <b>UPLOAD</b> button to upload the latest version.
            </v-card-text>
            <v-divider></v-divider>
            <v-row class="pa-4">
                <btn_component ref="createFaq" tooltip="Add new Faq" type="text" size="small" text="Add Faq" data="" @actionClick="createFaq"/>
                <v-spacer></v-spacer>
                <span class="pl-4">
                    <btn_component ref="upload" tooltip="Upload to OpenAI" type="text" size="small" text="Upload" data="" @actionClick="uploadFiles"/>
                </span>
                <span class="pl-4">
                    <v-btn class="primary" small @click="buildReport" :disabled="disableExport" color="success">
                        <v-icon small class="pr-2">mdi-microsoft-excel</v-icon>
                        <span>Export</span>
                    </v-btn>
                </span>
            </v-row>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="6"><v-text-field v-model="search" label="Search faq's" single-line hide-details prepend-icon="mdi-magnify"></v-text-field></v-col>
                <v-col cols="3"><selector ref="language" :options="languageCodes" option_field="languageCodesSelected" label="Filter on language" :visibleChips=4 @updateData="updateData"/></v-col>
                <v-col cols="3"><selector ref="category" :options="categoryCodes" option_field="categoryCodesSelected" label="Filter on category" :visibleChips=4 @updateData="updateData"/></v-col>
            </v-row>
            <v-divider></v-divider>
            <v-data-table 
                :items="filteredFaqs" 
                :items-per-page="10" 
                :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                :headers="headers"
                :search="search">
                <template v-slot:item="props">
                    <tr>
                        <!-- <td @click="$router.open('/pten/onPten/' + props.item.pten_encrid)"><a>{{ props.item.pten_code }}</a></td> -->
                        <td>{{ props.item.language }}</td>
                        <td>{{ props.item.categoryOms }}</td>
                        <td>{{ props.item.number }}</td>
                        <td><longTextView :long_text="props.item.question" :max_width="300"/></td>
                        <td><longTextView :long_text="props.item.answer" :max_width="600"/></td>
                        <td>
                            <v-row cols="12">
                                <v-col cols="6">
                                    <btn_component ref="editFaq" tooltip="Edit Faq" type="text" size="x-small" text="Edit Faq" :data="props.item" @actionClick="editFaq"/>
                                </v-col>
                                <v-col  cols="6">
                                    <btn_component ref="deleteFaq" tooltip="Delete Faq" type="text" size="x-small" text="Delete Faq" color="error" :data="props.item" @actionClick="deleteFaq"/>
                                </v-col>
                            </v-row>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <cardFaqDelete ref="cardFaqDelete" @actionClick="actionClick"/>
        <cardFaqEdit ref="cardFaqEdit" @actionClick="actionClick"/>
        <cardFaqUpload ref="cardFaqUpload" title="website faq"/>
        <showProgress ref="showProgress"/>
    </v-container>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import longTextView from "@/components/ui/fields/longTextView.vue";
    import selector from "@/components/ui/selectors/selector.vue";
    import showProgress from "@/components/showProgress.vue";

    import cardWait from "@/components/syst/openai/cardWait.vue";
    import cardFaqDelete from "@/components/syst/openai/cardFaqDelete.vue";
    import cardFaqEdit from "@/components/syst/openai/cardFaqEdit.vue";
    import cardFaqUpload from "@/components/syst/openai/cardFaqUpload.vue";

    export default {
        components: {
            btn_component,
            longTextView,
            selector,
            showProgress,
            cardWait,
            cardFaqDelete,
            cardFaqEdit,
            cardFaqUpload,
        },
        props: {
        },
        data() {
            return {
                loading: true,
                firstTime: true,
                disableExport: false,

                faqTooltip: "Copy of website faq's. Any changes here are NOT synchronised to the website. (My Villa faq's are not active on the website)",
                
                categoryCodes: [],
                categoryCodesSelected: [],
                
                languageCodes: [],
                languageCodesSelected: [],

                files: [],
                
                search: "",
                headers: [
                    {text: 'Language', value: 'language', width: "50px", tdClass: 'align-text-top' },
                    {text: 'Category', value: 'categoryOms', width: "50px", tdClass: 'align-text-top'},
                    {text: 'Number', value: 'number', width: "25px", tdClass: 'align-text-top'},
                    {text: 'Question', value: 'question', width: "250px", tdClass: 'align-text-top'},
                    {text: 'Answer', value: 'answer', width: "500px", tdClass: 'align-text-top' },
                    {text: 'Actions', value: '', width: "150px", tdClass: 'align-text-top'},
                ],
                faqs: [],
                filteredFaqs: [],
            }
        },
        mounted() {
            this.getFaqGeneral();
        },
        methods: {
            getFaqGeneral() {
                this.$axios.post("ares/json/ares/syst/openai/getFaqGeneral.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getFaqGeneral"
                    },
                    getFaqGeneral: {
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.faqs = res.data.getFaqGeneral.items;
                        this.files = res.data.getFaqGeneral.files;
                        this.languageCodes = res.data.getFaqGeneral.languageKeuzes;
                        this.categoryCodes = res.data.getFaqGeneral.categoryKeuzes;
                        if (this.firstTime) {
                            this.languageCodesSelected = res.data.getFaqGeneral.languageKeuzes;
                            this.categoryCodesSelected = res.data.getFaqGeneral.categoryKeuzes;
                            this.firstTime = false;
                        }
                        this.filterFaqs();
                        this.loading = false;
                    }
                });
            },
            inOptions(option, selectedOptions) {
                for (let i=0; i<selectedOptions.length; i++) {
                    if (option === selectedOptions[i].Option) {
                        return true;    
                    }
                }   
                return false;    
            },
            filterFaqs() {
                this.filteredFaqs = [];

                for (let i=0; i<this.faqs.length; i++) {
                    if (this.inOptions(this.faqs[i].language, this.languageCodesSelected) && this.inOptions(this.faqs[i].categoryCode, this.categoryCodesSelected)) {
                        this.filteredFaqs.push(this.faqs[i]);
                    }
                }
            },
            updateSelection(selectedField, codeField, newSelection) {
                //console.log(newSelection);
                this[selectedField] = newSelection;
                for (let i=0; i<this[codeField].length; i++) {
                    this[codeField][i].isSelected = false;
                    for (let j=0; j<this[selectedField].length; j++) {
                        if (this[codeField][i].Option === this[selectedField][j].Option) {
                            this[codeField][i].isSelected = true;
                        }
                    }
                }
            },
            updateData(data) {
                switch (data.field) {
                    case "languageCodesSelected":
                        this.updateSelection("languageCodesSelected", "languageCodes", data.value);
                        this.filterFaqs();
                        break;
                    case "categoryCodesSelected":
                        this.updateSelection("categoryCodesSelected", "categoryCodes", data.value);
                        this.filterFaqs();
                        break;
                    default:
                        console.log("updateData - field not found: ", data);
                }
            },
            uploadFiles() {
                this.$refs.cardFaqUpload.openDialog(this.files);
            },
            actionClick(action) {
                switch (action) {
                    case "refresh":
                        this.getFaqGeneral();
                        break;
                }
            },
            showInfo() {
            },
            createFaq() {
                let newFaq = {
                    oava_encrid: "",
                    language: "",
                    categoryCode: "",
                    question: "",
                    answer: "",
                }
                this.$refs.cardFaqEdit.openDialog(newFaq, this.languageCodes, this.categoryCodes);
            },
            deleteFaq(faq) {
                this.$refs.cardFaqDelete.openDialog(faq);
            },
            editFaq(faq) {
                this.$refs.cardFaqEdit.openDialog(faq, this.languageCodes, this.categoryCodes);
            },
            buildReport() {
                this.disableExport = true;
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/syst/openai/excelExportFaqGeneral.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelExportFaqGeneral"
                    },
                    excelExportFaq: {
                        items: this.filteredFaqs,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        window.open(res.data.excelExportFaqGeneral.filename, '_blank');
                    }
                    this.$refs.showProgress.close();
                    this.disableExport = false;
                });
            },
        }
    };
</script> 

<style scoped>
    .align-text-top {
        vertical-align: top;
    }
</style>
